<!-- /**
 * @author Ketan Shetye
 * @created 2025-11-24
 */ -->
@if (context.client?.name !== '' && menuItems !== null) {
<!-- main container -->
<div class="main-container">
  <!-- header container -->
  <div class="header-container">
    <!-- logo container -->
    <div class="logo-container clickable" (click)="onGeoPermitLogoClick()">
      <!-- logo -->
      <img [src]="clientAdminJanusAssets.geoPermitsLogo" alt="GeoPermits Logo" class="geopermit-logo" />
      @if (context.client?.logoURL) {
      <img [src]="context.client?.logoURL" alt="GeoPermits Logo" class="dummyseal-logo" />
      }@else {
      <img [src]="clientAdminJanusAssets.geoPermitsLogo" alt="GeoPermits Logo" class="dummyseal-logo" />
      }

    </div>
    <!-- Jurisdiction container -->
    @if (jurisdictions.length > 1) {
    <div class="jurisdiction-container clickable" [matMenuTriggerFor]="jurisdictionSwitcherMenu">
      <wm-common-text [data]="{text:context.client?.name}"></wm-common-text>
      <wm-common-icon [data]="{iconName:clientAdminJanusAssets.keyBoardDropDownIcon}"></wm-common-icon>
    </div>
    }@else {
    <div class="jurisdiction-container">
      <wm-common-text [data]="{text:context.client?.name}"></wm-common-text>
    </div>
    }
    @if (context.client?.mode === 0) {
    <span class="jurisdiction-test-mode-indicator" role="status" aria-label="Test Mode">TEST MODE</span>
    }
    <!-- jurisdiction switcher -->
    <mat-menu #jurisdictionSwitcherMenu="matMenu" yPosition="below" xPosition="after">
      <div class="jurisdiction-switcher-menu-card"
        [ngClass]="{'scrollable-jurisdiction-switcher-menu-card': jurisdictions.length > 5 }">
        @if (jurisdictionsFetchError) {
        <wm-common-text [data]="{text:jurisdictionsFetchError}"></wm-common-text>
        }@else {
        @if (jurisdictionsFetching === false) {
        @if(jurisdictions.length > 4){
        <div (click)="$event.stopPropagation()">
          <wm-common-textfield [data]="jurisdictionSearchFieldConfig" [(ngModel)]="jurisdictionSearchQuery"
            (ngModelChange)="handleJurisdictionSearchChange($event)">
          </wm-common-textfield>
        </div>
        }
        @for (jurisdiction of displayJurisdictions; track $index) {
        <div [ngClass]="{'active-jurisdiction' : jurisdiction.id === clientId}"
          style="height: auto; padding: 0; line-height: normal;">
          <span style="display: none;">{{ jurisdiction.name }}</span>
          <wm-common-button [data]="onJurisdictionMenuItemClick(jurisdiction)"></wm-common-button>
        </div>
        }
        }@else {
        <mat-progress-spinner mode="indeterminate" diameter="48">
        </mat-progress-spinner>
        }
        }

      </div>
    </mat-menu>

    <!-- account container -->
    <div
      class="account-container clickable"
      [matMenuTriggerFor]="isMobileProfileView ? null : profileMenu"
      (click)="openMobileProfileMenu($event)"
    >
      <!-- Start Code added by Sanchit on 05/06/2026 -->
      <span class="profile-name-typo">
        {{context.user?.name}}
      </span>
      <!-- End Code added by Sanchit on 05/06/2026 -->
      @if (context.user?.userProfileImageURL) {
      <img [src]="context.user?.userProfileImageURL" alt="Profle Image" class="profile-image" />
      }@else {
      <img [src]="clientAdminJanusAssets.dummyProfilePic" alt="Profle Image" class="profile-image" />
      }
    </div>
    <!-- profile menu card -->
    <mat-menu #profileMenu="matMenu" yPosition="below" xPosition="after">
      <div class="profile-menu-card">
        <wm-common-button [data]="getEditProfileButtonData()"></wm-common-button>
        <wm-common-button [data]="onSignOutClick()"></wm-common-button>
      </div>
    </mat-menu>

    @if (isMobileProfileView && isMobileProfileMenuOpen) {
    <div class="mobile-profile-overlay" (click)="closeMobileProfileMenu()">
      <section
        class="mobile-profile-drawer"
        role="dialog"
        aria-modal="true"
        aria-label="Account Settings"
        (click)="$event.stopPropagation()"
      >
        <header class="mobile-profile-header">
          <span>Account Settings</span>
          <button
            type="button"
            class="mobile-profile-close"
            aria-label="Close account settings"
            (click)="closeMobileProfileMenu()"
          >
            <wm-common-icon [data]="{iconName: clientAdminJanusAssets.closeIcon}"></wm-common-icon>
          </button>
        </header>
        <div class="mobile-profile-options">
          <button type="button" (click)="handleMobileEditProfile()">Edit Profile</button>
          <button type="button" (click)="handleMobileSignOut()">Sign Out</button>
        </div>
      </section>
    </div>
    }


  </div>
  <!-- body container-desktop -->
  <!-- Updated by Amisha on 2026-09-23.
       Reason: allow only Users mobile content to reach the page edges without
       changing the shared spacing used by Applications, Renewals, and Workflows. -->
  <div
    class="body-container"
[class.users-mobile-full-width]="['Users', 'Settings', 'Help','Workflows','Reports'].includes(getCurrentMenuName())"


  >
          <!-- [class.mobile-full-width]="getCurrentMenuName() === 'Settings' ||getCurrentMenuName() === 'Help' " -->

    <!-- primary drawer container -->
    <div class="primary-drawer-container-desktop">
      <!-- seal container -->
      @if (context.client?.logoURL) {
      <div class="seal-container">
        <!-- seal -->
        <img [src]="context.client?.logoURL" alt="Seal" class="seal" />
      </div>
      }

      <!-- department switcher container -->
      @if (departments.length === 1) {
      <div class="department-switcher-container">
        <wm-common-text [data]="{text:departmentName,textTransform:'uppercase'}"></wm-common-text>
      </div>
      }@else {
      <div class="department-switcher-container clickable" [matMenuTriggerFor]="departmentMenu">
        <wm-common-text [data]="{text:departmentName,textTransform:'uppercase'}"></wm-common-text>
        <wm-common-icon [data]="{iconName:clientAdminJanusAssets.keyBoardDropDownIcon}"></wm-common-icon>
      </div>
      <!-- Department dropdown menu -->
      <mat-menu #departmentMenu="matMenu" yPosition="below" xPosition="after">

        <div class="department-switcher-menu-card"
          [ngClass]="{'scrollable-department-switcher-menu-card': departments.length > 5 }">
          @if (deparmentsFetchError) {
          <wm-common-text [data]="{text:deparmentsFetchError}"></wm-common-text>
          }@else {
          @if (departmentsFetching === false) {
          @if(departments.length > 3){
          <div (click)="$event.stopPropagation()">
            <wm-common-textfield [data]="departmentSearchFieldConfig" [(ngModel)]="departmentSearchQuery"
              (ngModelChange)="handleDepartmentSearchChange($event)">
            </wm-common-textfield>
          </div>
          }
          @for (dept of displayDepartments; track $index) {
          <div [ngClass]="{'active-department' : dept.id === departmentId}">
            <wm-common-button [data]="onDepartmentMenuItemClick(dept)"></wm-common-button>
          </div>
          }
          }@else {
          <mat-progress-spinner mode="indeterminate" diameter="48">
          </mat-progress-spinner>
          }
          }

        </div>
      </mat-menu>
      }



      <!-- primary drawer main container -->
      <div class="primary-drawer-main-container-desktop">
        @for (primaryDrawerItem of menuItems; track $index) {
        @if (primaryDrawerItem.canView){
        <div class="primary-drawer-button"
          [ngClass]="{ 'active-primary-drawer-button': isActive(primaryDrawerItem.url) }">
          <ng-template #primaryDrawerButtonTemplate>
            <wm-common-text [data]="{
                    text:primaryDrawerItem.name
                }"></wm-common-text>
          </ng-template>
          <wm-common-button
            [data]="getPrimaryDrawerButtonData(primaryDrawerButtonTemplate,primaryDrawerItem.url)"></wm-common-button>
        </div>
        }
        }
      </div>
    </div>
    <!-- primary-drawer-container-mobile -->
    <div class="primary-drawer-container-mobile">
      <ng-template #hamburgerIconTemplate>
        <wm-common-icon [data]="{iconName:clientAdminJanusAssets.hamburgerIcon}"></wm-common-icon>
      </ng-template>
      <wm-common-button [data]="getHamburgerIconButtonData(hamburgerIconTemplate)" class="hamburger-button"></wm-common-button>
      <wm-common-text [data]="{text: getCurrentMenuName()}"></wm-common-text>
    </div>

    <!-- inner body container -->
    <div class="inner-body-container" [class.help-mobile-alinment]="getCurrentMenuName() === 'Help'"
>
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- added by furkan 17-03-2026 for mobile view primary drawer and department switcher  -->
  @if (isMobilePrimaryDrawerModalOpen) {
  <div class="mobile-drawer-overlay" (click)="closeMobileDrawer()">
    <div class="mobile-drawer-card" (click)="$event.stopPropagation()">
      @if (mobileDrawerState === 'menu') {
      <div class="mobile-drawer-header">
        <div class="mobile-drawer-dept-btn clickable" (click)="openMobileDepartments()">
          <wm-common-text [data]="{text: departmentName, textTransform: 'capitalize'}"></wm-common-text>
          <wm-common-icon [data]="{iconName: clientAdminJanusAssets.arrowForwardIcon}"></wm-common-icon>
        </div>
        <div class="mobile-drawer-close-btn clickable" (click)="closeMobileDrawer()">
          <wm-common-icon [data]="{iconName: clientAdminJanusAssets.closeIcon}"></wm-common-icon>
        </div>
      </div>
      <div class="mobile-drawer-body">
        @for (primaryDrawerItem of menuItems; track $index) {
        @if (primaryDrawerItem.canView){
        <div class="mobile-drawer-item" [ngClass]="{ 'active-mobile-drawer-item': isActive(primaryDrawerItem.url) }">
          <ng-template #mobileDrawerButtonTemplate>
            <wm-common-text [data]="{text:primaryDrawerItem.name}"></wm-common-text>
          </ng-template>
          <wm-common-button
            [data]="getPrimaryDrawerButtonData(mobileDrawerButtonTemplate, primaryDrawerItem.url, true)"></wm-common-button>
        </div>
        }
        }
      </div>
      }

      @else if (mobileDrawerState === 'departments') {
      <div class="mobile-drawer-header">
        <div class="mobile-drawer-back-btn clickable" (click)="closeMobileDepartments()">
          <wm-common-icon [data]="{iconName: clientAdminJanusAssets.arrowBackIcon}"></wm-common-icon>
          <wm-common-text [data]="{text: 'Department Selection', textTransform: 'capitalize'}"></wm-common-text>
        </div>
      </div>
      <div class="mobile-drawer-body">
        @if (deparmentsFetchError) {
        <wm-common-text [data]="{text:deparmentsFetchError}"></wm-common-text>
        } @else {
        @if (departmentsFetching === false) {
        @for (dept of departments; track $index) {
        <div class="mobile-drawer-item" [ngClass]="{'active-department' : dept.id === departmentId}">
          <wm-common-button [data]="onDepartmentMenuItemClick(dept, true)"></wm-common-button>
        </div>
        }
        } @else {
        <mat-progress-spinner mode="indeterminate" diameter="48">
        </mat-progress-spinner>
        }
        }
      </div>
      }
    </div>
  </div>
  }
  <!-- ended by furkan 17-03-2026 for mobile view primary drawer and department switcher  -->

</div>
}@else {
<div style="display: flex;justify-content: center;align-items: center;height: 100lvh;">
  <mat-progress-spinner mode="indeterminate" diameter="48">
  </mat-progress-spinner>
</div>
}
<!-- sign out modal -->
<wm-common-confirmation-modal [data]="signOutModalData" (onYesClick)="handleSignOutModalAccepted()"
  (onNoClick)="handleSignOutModalModalRejected()">
</wm-common-confirmation-modal>
